var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49902 4.85271C3.49902 4.06813 4.15305 3.4321 4.95984 3.4321H42.941C43.7478 3.4321 44.4018 4.06813 44.4018 4.85271V29.0031C44.4018 29.7876 43.7478 30.4237 42.941 30.4237H4.95984C4.15305 30.4237 3.49902 29.7876 3.49902 29.0031V4.85271ZM6.42065 6.27332V27.5825H41.4802V6.27332H6.42065Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9505 27.5825C24.4389 27.5825 24.895 27.8198 25.1659 28.2151L33.9308 41.0005C34.3783 41.6533 34.1969 42.5354 33.5257 42.9706C32.8544 43.4058 31.9474 43.2294 31.4999 42.5766L23.9505 31.5641L16.401 42.5766C15.9535 43.2294 15.0466 43.4058 14.3753 42.9706C13.704 42.5354 13.5226 41.6533 13.9701 41.0005L22.735 28.2151C23.0059 27.8198 23.462 27.5825 23.9505 27.5825Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34229 10.5351C9.34229 9.75056 9.99631 9.11453 10.8031 9.11453H19.568C20.3748 9.11453 21.0288 9.75056 21.0288 10.5351C21.0288 11.3197 20.3748 11.9558 19.568 11.9558H10.8031C9.99631 11.9558 9.34229 11.3197 9.34229 10.5351ZM9.34229 16.2176C9.34229 15.433 9.99631 14.797 10.8031 14.797H19.568C20.3748 14.797 21.0288 15.433 21.0288 16.2176C21.0288 17.0022 20.3748 17.6382 19.568 17.6382H10.8031C9.99631 17.6382 9.34229 17.0022 9.34229 16.2176ZM9.34229 21.9C9.34229 21.1154 9.99631 20.4794 10.8031 20.4794H19.568C20.3748 20.4794 21.0288 21.1154 21.0288 21.9C21.0288 22.6846 20.3748 23.3206 19.568 23.3206H10.8031C9.99631 23.3206 9.34229 22.6846 9.34229 21.9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2548 11.9558C28.8344 11.9558 26.8723 13.8638 26.8723 16.2176C26.8723 18.5713 28.8344 20.4794 31.2548 20.4794C33.6751 20.4794 35.6372 18.5713 35.6372 16.2176C35.6372 13.8638 33.6751 11.9558 31.2548 11.9558ZM23.9507 16.2176C23.9507 12.2947 27.2208 9.11453 31.2548 9.11453C35.2887 9.11453 38.5588 12.2947 38.5588 16.2176C38.5588 20.1405 35.2887 23.3206 31.2548 23.3206C27.2208 23.3206 23.9507 20.1405 23.9507 16.2176Z",
    fill: "#9EC6E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.e56452a253a7572a97d674bd88a44848.svg";
export { ForwardRef as ReactComponent };